
import { createMuiTheme } from '@material-ui/core/styles';
// import indigo from '@material-ui/core/colors/indigo';
// import orange from '@material-ui/core/colors/orange';
// import pink from '@material-ui/core/colors/pink';
import red from '@material-ui/core/colors/red';
// import gray from "@material-ui/core/colors/orange"
const myTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#EF8354"
        },
        secondary: {
            main: "#EF8354"
        },
        error: red,
        contrastThreshold: 3,
        // tonalOffset: 0.2,
        textColor: '#ffffff',
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    overrides: {
        MuiButton: {
            colorInherit: false,
            containedPrimary: {
                color: "#ffffff"
            }
        },
        // MuiAppBar:{
        //     //     colorDefault:{
        //     //         color:"#ffffff",
        //     //         // textColor:"red"
        //     //     }
        //     // },

        //     // MuiMenuItem:{
        //     //     gutters:{
        //     //         backgroundColor:"#EF8354",
        //     //     }
        //     // },
        //     // MuiPaper:{
        //     //     root:{
        //     //         marginLeft:"-5.5%",

        //     //     }
        //     // },
        //     // MuiInputBase:{
        //     //     root:{
        //     //         width:"100%"
        //     //     }
        //     // }

    }


});
export default myTheme;